import { BudgetVersionType } from './../shared/enum/budgetVersionType.enum';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { IBudgetSalary } from '../budgets/budget-salaries/budget-salaries.model';
import { BudgetDetailSearch } from '../shared/model/budget-detail.model';

@Injectable({
    providedIn: 'root',
})
export class BudgetSalaryService {
    baseUrl = '/school-service/api/budget-salary';

    constructor(private http: HttpClient) {}

    getBySearch(
        budgetId: string,
        costCenterId: string,
        budgetVersion: BudgetVersionType
    ): Observable<HttpResponse<IBudgetSalary[]>> {
        const searchDTO = new BudgetDetailSearch();
        searchDTO.budgetId = budgetId;
        searchDTO.costCenterId = costCenterId;
        searchDTO.version = budgetVersion;
        return this.http.post<IBudgetSalary[]>(`${this.baseUrl}/search`, searchDTO, { observe: 'response' });
    }

    getCalculatedSalaries(
        budgetId: string,
        costCenterId: string,
        salaryPlanId: string
    ): Observable<HttpResponse<IBudgetSalary[]>> {
        return this.http.get<IBudgetSalary[]>(
            `${this.baseUrl}/budget/${budgetId}/cost-center/${costCenterId}/calculate` +
                `?salaryPlanId=${salaryPlanId}`,
            {
                observe: 'response',
            }
        );
    }

    saveAll(
        budgetId: string,
        costCenterId: string,
        budgetVersion: BudgetVersionType,
        budgetSalaries: IBudgetSalary[]
    ): Observable<HttpResponse<any>> {
        return this.http.post<any>(
            `${this.baseUrl}/budget/${budgetId}/cost-center/${costCenterId}/version/${budgetVersion}/save`,
            budgetSalaries,
            {
                observe: 'response',
            }
        );
    }

    approveByBudgetId(budgetId: string, budgetVersion: BudgetVersionType): Observable<HttpResponse<IBudgetSalary[]>> {
        return this.http.patch<any>(`${this.baseUrl}/budget/${budgetId}/version/${budgetVersion}/approve`, {
            observe: 'response',
        });
    }

    unapproveByBudgetId(budgetId: string, budgetVersion: BudgetVersionType): Observable<HttpResponse<IBudgetSalary[]>> {
        return this.http.patch<any>(`${this.baseUrl}/budget/${budgetId}/version/${budgetVersion}/unapprove`, {
            observe: 'response',
        });
    }

    deleteByBudgetId(budgetId: string): Observable<HttpResponse<any>> {
        return this.http.delete(`${this.baseUrl}/budget/${budgetId}`, {
            observe: 'response',
        });
    }

    deleteByBudgetIdAndCostCenterId(
        budgetId: string,
        costCenterId: string,
        budgetVersion: BudgetVersionType
    ): Observable<HttpResponse<any>> {
        return this.http.delete(
            `${this.baseUrl}/budget/${budgetId}/cost-center/${costCenterId}/version/${budgetVersion}`,
            {
                observe: 'response',
            }
        );
    }
}
